import React, { FunctionComponent, useContext, PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';
import { ShoppingPlannerContext } from '../../Context/ShoppingPlannerContext';
import { useResponsive } from '../../Hook/UseResponsive';
import { ShoppingListMobile } from '../../Pages/ShoppingList/ShoppingListMobile';
import { Header } from '../Header/Header';
import { Icon } from '../Icon/Icon';
import { InfoBar } from '../Infobar/Infobar';

import './BaseLayout.scss';

interface BaseLayoutProps {
    className?: string;
    hideInfoBar?: boolean;
}

export const BaseLayout: FunctionComponent<PropsWithChildren<BaseLayoutProps>> = (props) => {
    const { isLargerThanMd } = useResponsive();
    const { shoppingListMobileVisible, setShoppingListMobileVisible } = useContext(ShoppingPlannerContext);

    const location = useLocation();

    React.useEffect(() => {
        setShoppingListMobileVisible(false);
    }, [location]);

    return (
        <div className={['shopping-planner', props.className ?? ''].join(' ')}>
            <Header />
            <main className="shopping-planner__main">{props.children}</main>
            {props.hideInfoBar ? null : <InfoBar />}
            {isLargerThanMd ? null : (
                <div
                    className={[
                        'shopping-list-mobile-overlay',
                        shoppingListMobileVisible ? 'shopping-list-mobile-overlay--visible' : '',
                    ].join(' ')}
                >
                    <button
                        type="button"
                        className="shopping-planner-shopping-list-mobile__close"
                        onClick={() => {
                            setShoppingListMobileVisible(false);
                        }}
                    >
                        <Icon icon="close" />
                    </button>
                    <ShoppingListMobile />
                </div>
            )}
        </div>
    );
};
